<template>
  <el-container>
    <el-header height="220">
      <h3>文章分类</h3>
      <el-row style="margin-top: 10px">
        <el-select
          v-model="queryInfo.type"
          style="margin-left: 5px"
          @change="onSelectChange"
        >
          <el-option label="category" value="category" />
          <el-option label="tag" value="tag" />
        </el-select>
        <el-button type="success" icon="el-icon-plus" style="margin-left: 5px" @click="handleAdd">添加</el-button>
      </el-row>
    </el-header>
    <el-main>
      <el-col :md="12">
        <el-table
          :data="dataList"
          border
          height="480"
          style="width: 100%"
        >
          <el-table-column
            fixed="left"
            label="No"
            type="index"
          />
          <el-table-column
            prop="name"
            label="分类"
          >
            <template slot-scope="scope">
              <el-tag disable-transitions>
                <span>{{ scope.row.name }}</span>
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="total"
            label="文章总数"
          />
          <el-table-column
            fixed="right"
            label="操作"
            width="280"
          >
            <template slot-scope="scope">
              <el-button
                style="margin-top: 5px; margin-left: 5px"
                size="mini"
                type="danger"
                @click="handleDelete(scope.$index, scope.row)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>

      <el-dialog
        title="添加分类"
        append-to-body
        :visible.sync="addDialog"
        width="30%"
        center
      >
        <template>
          <el-form :model="addForm" label-width="80px">
            <el-form-item label="分类">
              <el-input v-model="addForm.name" style="width: 70%; padding-right: 2px" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onAdd">确定</el-button>
            </el-form-item>
          </el-form>
        </template>
      </el-dialog>
    </el-main>
  </el-container>
</template>

<script>
import { addBlogCategory, deleteBlogCategory, getBlogCategoryList } from '@/api/blog'

export default {
  name: 'BlogCategory',
  data() {
    return {
      queryInfo: {
        type: 'category'
      },
      dataList: [],
      addDialog: false,
      addForm: {
        name: null
      }
    }
  },
  created() {
    const type = this.$route.query.type
    if (type !== undefined && type !== null) {
      this.queryInfo.type = type
    }

    document.title = '文章分类'
    this.getData()
  },
  methods: {
    getData() {
      getBlogCategoryList(this.queryInfo).then(resp => {
        if (resp.code === 0) {
          this.dataList = resp.data
        } else {
          this.$message.error(resp.msg)
        }
      }).catch(error => {
        this.$message.error(error.message)
      })
    },
    handleAdd() {
      this.addDialog = true
    },
    onAdd() {
      this.addDialog = false
      const formData = new FormData()
      formData.append('name', this.addForm.name)
      addBlogCategory(formData).then(resp => {
        this.addDialog = false
        this.$message.info(resp.msg)
        this.getData()
      }).catch(error => {
        this.$message.error(error.message)
      })
    },
    handleDelete(index, row) {
      this.$confirm('确定要删除 ' + row.name + '?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const formData = new FormData()
        formData.append('id', row.id)
        deleteBlogCategory(formData).then(resp => {
          this.$message.info(resp.msg)
          this.getData()
        }).catch(error => {
          this.$message.error(error.message)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    onSelectChange() {
      this.$router.push({
        path: '/bg/blog/category',
        query: this.queryInfo
      })
      this.getData()
    }
  }
}
</script>

<style scoped>
</style>
